export const APP_FILE_ADDRESS_HISTORY_ROUTE = "/habitational-policy/:customerId/address-history/:customerPolicyId";